<template>
   <billing-Layout>
  <slot>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">ePrint Setup</h4>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex align-items-right justify-content-end">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name:'Setting'}" class="btn btn-info btn-sm mr-2"><i class="fas fa-arrow-left"></i> Back</router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    <div class="container-fluid">
       <div class="card card-body estilosform">
        <div class="row">
          
            <div class="col-8">
                <table class="table" style="width:450px;">
                  <tr>
                    <td style="width:130px;">HP ePrint email</td>
                    <td style="width:200px;">{{FormEPrint.email1}}</td>
                    <td style="width:30px;"><button @click="SendTestePrint(1)"><i class="fas fa-print"></i></button> </td>

                  </tr>
                  <tr>
                    <td style="width:130px;">HP ePrint email 2</td>
                    <td style="width:200px;">{{FormEPrint.email2}}</td>
                    <td style="width:30px;"><button @click="SendTestePrint(2)"><i class="fas fa-print"></i></button></td>

                  </tr>
              </table>
              </div>
              <div class="col-4 text-right">
                <button type="button" class="btn btn-success" @click="MetUpdateEprint"><i class="fas fa-edit"></i> Edit</button>
              </div>
            </div>

        </div>
    </div>
    <modal name="setting-eprint" height="auto">
         <div class="card-header"><i class="fas fa-edit"></i> EDIT <button @click="closeModal" class="closeIcon"><span></span></button></div>
            <div class="card-body">

            <form @submit.prevent="UpdateEmilePrint">
            <div class="form-row">

                <div class="col-6">
                <span id="emailHelp" class="form-text text-muted"> HP ePrint email</span>
                <input type="text" class="form-control" v-model="FormEPrint.email1">
                </div>
                <div class="col-6">
                <span id="emailHelp" class="form-text text-muted"> HP ePrint email 2</span>
                <input type="text" class="form-control" v-model="FormEPrint.email2">
                </div>

                <div class="col-12">
                  <small id="emailHelp" class="form-text text-muted">.</small>
                  <button type="submit" class="btn btn-success float-right">SAVE</button>
                </div>
            </div>
            </form>

            </div>
        </modal>
</slot>
    <notifications group="noti" position="top center"></notifications>
   </billing-Layout> 
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'

export default {
  components:{
      BillingLayout,
      Loader
  },
  data() {
    return {
        isLoading : false,
        FormEPrint : {
            action : 'update',
            user_id : null,
            email1 : '',
            email2 : '',
      }
    }
  },
   created(){
   this.getEprintemail();
    },
     methods:{
       closeModal(){
        this.$modal.hide('setting-chart')
        },
       SendTestePrint(email){
       console.log(email);
           this.isLoading = true
            window.billing.put('eprinttest/' + window.localuserdata,{
                    email : email,
                    email1 : this.FormEPrint.email1,
                    email2 : this.FormEPrint.email2
                })
                .then((response) => {
                   console.log(response.data.success);
                   if(response.data.success){
                     this.$notify({
                    group: 'noti',
                    title: 'UPDATED',
                    type: 'success',
                    text: 'Successfully sent'
                  });
             
                   }else{
                  this.$notify({
                    group: 'noti',
                    title: 'ERROR',
                    type: 'error',
                    text: 'An error has occurred'
                  });
                   }
                }).catch((error) => {
                  console.log(error);
                  this.$notify({
                    group: 'noti',
                    title: 'ERROR',
                    type: 'error',
                    text: 'An error has occurred'
                  });
                });
       },
          MetUpdateEprint(){
          this.$modal.show('setting-eprint');
           /*  this.FormTax = {
              btnNameTax : 'ADD',
              ActionTaxe : 'AddTaxe',
              state_id : 0,
              status : 1
            } */
          },
        
         getEprintemail() {
              this.isLoading = true
            window.billing.get('setting/' + window.localuserdata)
                .then((response) => {

                 this.FormEPrint.email1 = response.data.email1.meta_value
                 this.FormEPrint.email2 = response.data.email2.meta_value
                }).catch((error) => console.log(error));
        },
        UpdateEmilePrint(){
        if(this.FormEPrint.action == 'update'){
          window.billing.put('setting/' + window.localuserdata,{
                    email1 : this.FormEPrint.email1,
                    email2 : this.FormEPrint.email2
                }).then((response) => {
                  this.$modal.hide('setting-eprint')
                            if(response.data.success){
                               this.$notify({
                                  group: 'noti',
                                  title: 'UPDATED',
                                  type: 'success',
                                  text: 'Update Successful'
                                });
      
                    }
              }).catch((error) => console.log(error,this.isLoading = false)); 
          }
        },
  }
}
</script>
<style lang="scss">
  .estilosform{
    .col-form-label{
          color: #a5a5a5;
          padding-bottom: 0;
          font-size: 13px;
    }
  }
  .marginTop{
      margin-top:7px;
  }


</style>


